
import {
  defineComponent, onBeforeMount, reactive,
} from 'vue';
import { Modal } from 'ant-design-vue';
import Icone from '@/core/components/UI/Icone.vue';
import ComunicacaoApi from '@/core/components/UI/ComunicacaoApi.vue';
import { useAppBase } from '@/core/composables/AppBase';
import { IDTOCliente } from '@/models/DTO/IDTOCliente';
import ServicoCliente from '@/servicos/ServicoCliente';
import { IClienteParametrosConsulta } from '@/models/ParametrosRequisicao/Consulta/IClienteParametrosConsulta';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import { EStatusResposta, IResposta } from '@/core/models/IResposta';
import { IOptionString } from '@/core/models/AntDesign/IOption';
import { obterItem, salvarItem } from '@/core/gerenciadores/GerenciadorLocalStorage';
import { IDTOClienteCompleto } from '@/models/DTO/IDTOClienteCompleto';
import router from '@/router';

export default defineComponent({
  name: 'ClienteListagem',
  components: {
    Icone,
    ComunicacaoApi,
  },
  setup() {
    const { appBase, apresentarComunicacaoApi, apresentarResposta } = useAppBase();
    const servicoCliente = new ServicoCliente();

    const state = reactive({
      clientes: [] as IDTOClienteCompleto[],
      parametrosConsulta: {} as IClienteParametrosConsulta,
      apresentarFiltros: false,
      ordenarPor: 'CodigoClienteDESC',
      opcoesOrdenacao: [] as IOptionString[],
    });
    let debounce = 0;

    state.opcoesOrdenacao = [];
    const ordemMaisRecentes:IOptionString = { value: 'CodigoClienteDESC', label: 'Mais recentes' } as IOptionString;
    const ordemNomeAsc:IOptionString = { value: 'NomeClienteASC', label: 'Nome (A-Z)' } as IOptionString;
    const ordemNomeDesc:IOptionString = { value: 'NomeClienteDESC', label: 'Nome (Z-A)' } as IOptionString;
    state.opcoesOrdenacao.push(ordemMaisRecentes);
    state.opcoesOrdenacao.push(ordemNomeAsc);
    state.opcoesOrdenacao.push(ordemNomeDesc);

    async function buscarDados() {
      appBase.carregando = true;
      state.apresentarFiltros = false;
      state.clientes = [];
      if (UtilitarioGeral.valorValido(state.ordenarPor)) {
        state.parametrosConsulta.ordenacao = [];
        state.parametrosConsulta.ordenacao.push(state.ordenarPor);
        salvarItem('CLIENTES-ORDERNACAO', state.ordenarPor);
      }

      if (appBase.paginacao.paginaAtual > 0) { state.parametrosConsulta.numeroPagina = appBase.paginacao.paginaAtual; }
      if (appBase.paginacao.qtdeRegistrosPagina > 0) { state.parametrosConsulta.qtdeRegistrosPagina = appBase.paginacao.qtdeRegistrosPagina; }

      const respostaConsulta = await servicoCliente.obterClientesDadosCompletos(state.parametrosConsulta);
      if (UtilitarioGeral.validaLista(respostaConsulta.dados)) {
        state.clientes = respostaConsulta.dados;
        appBase.paginacao = respostaConsulta.paginacao;
      }

      appBase.carregando = false;
    }

    function montarApresentacaoEndereco(cliente:IDTOClienteCompleto): string {
      let enderecoCompleto = cliente.endereco;
      if (UtilitarioGeral.valorValido(cliente.numero)) {
        enderecoCompleto += `, ${cliente.numero}`;
      }
      if (UtilitarioGeral.valorValido(cliente.complemento)) {
        enderecoCompleto += `, ${cliente.complemento}`;
      }

      if (UtilitarioGeral.valorValido(cliente.bairro)) {
        enderecoCompleto += `, ${cliente.bairro}`;
      }
      return enderecoCompleto;
    }

    function montarApresentacaoCidadeCepEndereco(cliente:IDTOClienteCompleto): string {
      let enderecoCompleto = cliente.cidade;

      if (UtilitarioGeral.valorValido(cliente.uf)) {
        enderecoCompleto += `-${cliente.uf}`;
      }

      if (UtilitarioGeral.valorValido(cliente.cep)) {
        enderecoCompleto += ` CEP: ${UtilitarioMascara.mascararCEP(cliente.cep)}`;
      }

      return enderecoCompleto;
    }
    function buscarClientePorNome() {
      clearTimeout(debounce);
      debounce = setTimeout(async () => {
        await buscarDados();
      }, 600);
    }
    async function limparFiltros() {
      state.parametrosConsulta.status = undefined;
      await buscarDados();
    }
    onBeforeMount(async () => {
      const ordenacao = obterItem('CLIENTES-ORDERNACAO') as string;
      if (UtilitarioGeral.valorValido(ordenacao)) {
        state.ordenarPor = ordenacao;
      }
      await buscarDados();
    });

    async function paginacaAlterada(current: number, pageSize: number) {
      appBase.paginacao.paginaAtual = current;
      appBase.paginacao.qtdeRegistrosPagina = pageSize;
      await buscarDados();
    }
    async function qtdeRegistrosPaginaAlterada(current: number, pageSize: number) {
      appBase.paginacao.paginaAtual = 1;
      appBase.paginacao.qtdeRegistrosPagina = pageSize;
      await buscarDados();
    }

    async function deletarCliente(codigo: number) {
      appBase.resposta = {} as IResposta;
      apresentarComunicacaoApi('Aguarde por favor...');
      appBase.resposta = await servicoCliente.deletar(codigo);
      if (appBase.resposta.status === EStatusResposta.Sucesso) {
        const index = state.clientes.findIndex((u) => u.codigo === codigo);
        if (index >= 0) {
          state.clientes.splice(index, 1);
        }
      }
      apresentarResposta();
    }
    function confirmaExclusao(Cliente:IDTOCliente) {
      Modal.confirm({
        title: 'Você confirma a exclusão do cliente:',
        content: `${Cliente.nome} ?`,
        okText: 'Sim',
        okType: 'danger',
        cancelText: 'Não',
        autoFocusButton: null,
        onOk: async () => { await deletarCliente(Cliente.codigo); },
      });
    }
    function voltarTela() {
      router.push({
        name: 'Dashboard',
      });
    }
    return {
      appBase,
      state,
      UtilitarioMascara,
      buscarDados,
      limparFiltros,
      buscarClientePorNome,
      paginacaAlterada,
      qtdeRegistrosPaginaAlterada,
      confirmaExclusao,
      montarApresentacaoEndereco,
      montarApresentacaoCidadeCepEndereco,
      voltarTela,
    };
  },
});
